import { graphql } from '@/gql';

export const UsersForPerformanceResult = graphql(`
    query UsersForPerformanceResult($filter: UserFilteringRule, $pagination: Pagination, $sort: UserSortingRule) {
        users(filter: $filter, pagination: $pagination, sort: $sort) {
            count
            items {
                ...PerformanceResultUser
            }
        }
    }
`);

const PerformanceResultUser = graphql(`
    fragment PerformanceResultUser on User {
        ... on TenantUser {
            id
            name
        }
    }
`);
